<template>
    <div class="relative" data-cy="card_mission_transaction_item">
        <div data-cy="btn_mission_transaction_item_detail" @click="clickDetailMission()">
            <div v-if="missionCompleted && isShowStatus">
                <img v-if="localeCode == 1033" class="z-10 absolute left-0 right-0 top-14 mx-auto" src="@/assets/image/mission/transaction/img-mission-success-en.svg" alt="">
                <img v-else class="z-10 absolute left-0 right-0 top-14 mx-auto" src="@/assets/image/mission/transaction/img-mission-success-th.svg" alt="">
            </div>
            <div v-if="maxSubMissionQty && isShowStatus">
                <div class="z-10 absolute left-0 right-0 top-0 bottom-0 m-auto bg-white h-12 w-full flex justify-center items-center">
                    <img class="pr-1" src="@/assets/icon/ic-warning.svg" alt="">
                    <div class="text-a-red-ff4d4d text-16 font-bold ">{{ lbl.mission.max_qty }}</div>
                </div>
            </div>
        </div>
        <div class="rounded-lg my-4 p-4 relative"
            :class="[(missionCompleted || maxSubMissionQty) && isShowStatus ? 'opacity-40' : 'bg-mission-item',
                     mission.UI == null ? 'bg-mission-item' : 'bg-mission-special']">
            <div class="box-mission flex items-baseline relative" >
                <div class="text-14 box-text" :class="mission.UI == null ? 'text-a-blue-2140a6' : 'text-white'">
                    <div @click="clickDetailMission()">
                        <div class="text-16 font-bold pr-4" v-if="isShowAllTitle">{{ mission.CampaignName }}</div>
                        <div class="text-16 font-bold text-2-line pr-4 leading-snug" v-else>{{ mission.CampaignName }}</div>
                        <div class="mt-2">{{ mission.CampaignCaption }}</div>
                        <div v-if="mission.SubMissions">
                            <div class="mt-4 mb-[2px]">{{ lbl.mission.make_success }}{{ countMission }}/{{ mission.SubMissions.length }}</div>
                        </div>
                        <div v-else>
                            <div class="mt-4 mb-[2px]">{{ lbl.mission.make_success }}{{ FilterNumberFormat(mission.Count) }}/{{ FilterNumberFormat(mission.MissionCount) }}</div>
                        </div>
                    </div>
                    <div class="pr-5">
                        <ProgressBarMission
                            :indexItems="index"
                            :transactionMission="mission"
                            :missionSuccess="mission.Completed"
                            :indexActive="this.indexActive"
                        ></ProgressBarMission>
                    </div>
                    <div v-if="isShowBtn && !isBtnDisable && isShowBtnSpecial && isShowButton " data-cy="btn_mission_transaction_join" @click="clickJoinMission()"
                        class="mt-6 rounded-sm w-28 h-10 py-3"
                        :class="[mission.UI == null && !isBtnDisable ? 'bg-a-blue-2140a6 text-white' : isButtonSpecial ? 'bg-a-gray-c4c4c4 text-white' : 'bg-white text-a-blue-2140a6']">
                        <div class="text-14 font-bold text-center">{{ lbl.mission.btn_join }}</div>
                    </div>
                </div>
                <div class="box-img" @click="clickDetailMission()">
                    <div class="text-10 text-right" :class="[mission.UI == null ? 'text-a-blue-2140a6' : 'text-white']">{{ lbl.mission.timeCountDown }} {{ timeCountDown }} {{ lbl.mission.day }}</div>
                    <img :src="getImgMissionTransaction()" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import ProgressBarMission from './ProgressBarMission.vue';
//service
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import MissionService from '../../service/MissionService.js';

export default {
    name: "MissionTransaction",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    props: {
        mission:        { type: Object, required: true },
        index:          { type: Number, required: true },
        isShowButton:   { type: Boolean, default: true },
        isShowAllTitle: { type: Boolean, default: false },
        isShowStatus:  { type: Boolean, default: true },
    },
    components: {
        ProgressBarMission,
    },
    data: function() {
        return {
            countMission: 0,
            timeCountDown: null,
            missionCompleted: false,
            isButtonSpecial: true,
            indexActive: 0,
            isShowBtn: true,
            isBtnDisable: false,
            isShowBtnSpecial: true,
            maxSubMissionQty: false,
            //for join mission
            redeemId: '',
        }
    },
    created: async function() {
        this.modal.loadingModal.show();
        await this.getDataList();
        await this.getRedeemId();
        this.modal.loadingModal.hide();
    },
    methods: {
        getDataList: function() {
            if (this.mission.SubMissions) {
                this.checkMissionSpecial();
                this.isShowBtn = this.mission.MissionConfirm;
            } else {
                // let startDate = DatetimeHelper.unixTimestampToDate(this.mission.StartDate);
                let endDate = DatetimeHelper.unixTimestampToDate(this.mission.EndDate);
                let currentDate = new Date();
                this.timeCountDown = DatetimeHelper.calDiffInDay(currentDate, endDate);
                this.isShowBtn = this.mission.MissionConfirm;
                this.missionCompleted = this.mission.Completed;
                this.isBtnDisable = this.mission.Confirmed;
                if (this.mission.Confirmed && this.mission.CampaignQty == 0)  {
                    this.maxSubMissionQty = false;
                } else if (this.mission.CampaignQty == 0) {
                    this.maxSubMissionQty = true;
                } else {
                    this.maxSubMissionQty = false;
                }
            }
        },
        checkMissionSpecial: function() {
            let currentDate = new Date();
            let missionDate = this.mission.SubMissions.filter((item) =>{
                let start = DatetimeHelper.unixTimestampToDate(item.StartDate);
                let end = DatetimeHelper.unixTimestampToDate(item.EndDate);
                return (currentDate >= start  && currentDate <= end )
            })[0];
            let confirmed = this.mission.SubMissions.filter((item) => item.Confirmed == true)
            for (let i=0; i < this.mission.SubMissions.length; i++){
                let subMission = this.mission.SubMissions[i];
                let mission = this.checkMissionMonth(currentDate);
                // let stratDateSubMission = DatetimeHelper.unixTimestampToDate(subMission.StartDate);
                let endDateSubMission = DatetimeHelper.unixTimestampToDate(subMission.EndDate);

                if(parseInt(this.mission.Id) == 7){
                    let maxCount = this.mission.MaxLevel * subMission.MissionCount;
                    let currentCount = subMission.Count * subMission.CurrentLevel;
                    if(currentCount == maxCount){
                        this.countMission++;
                    }

                }else{
                    if (subMission.Count == subMission.MissionCount) {
                        this.countMission++;
                    }
                }

                if (this.countMission == this.mission.SubMissions.length) {
                    this.missionCompleted = subMission.Completed;
                }
                if (subMission) {
                    if (currentDate <= endDateSubMission) {
                        this.timeCountDown = DatetimeHelper.calDiffInDay(currentDate, endDateSubMission);
                        if (subMission.CampaignId != null) {
                            let maxQty = this.mission.SubMissions.slice(0, this.mission.SubMissions.length)
                            maxQty = maxQty.find(qty => {
                                return qty.CampaignQty == 0;
                            })
                            this.getDateMissionSpecial(subMission.StartDate, subMission.EndDate);
                            if (missionDate) {
                                let confirmedSpecial = missionDate.Confirmed;
                                let completedSpecial = missionDate.Completed;
                                let maxQtyInDate = missionDate.CampaignQty;
                                if (confirmedSpecial && (maxQtyInDate == 0)) {
                                    this.maxSubMissionQty = false;
                                    this.isBtnDisable = true;
                                } else if (maxQtyInDate == 0) {
                                    this.isBtnDisable = true;
                                    this.maxSubMissionQty = true;
                                    this.missionCompleted = false;
                                } else if (confirmedSpecial) {
                                    this.isBtnDisable = true;
                                    this.missionCompleted = false;
                                    this.isShowBtnSpecial = false;
                                } else {
                                    this.isBtnDisable = false;
                                    this.isButtonSpecial = false;
                                    this.maxSubMissionQty = false;
                                    this.missionCompleted = false;
                                }
                                if (completedSpecial) {
                                    this.missionCompleted = true;
                                    this.isBtnDisable = true;
                                }
                            } else {
                                let confirmOutPeriod = mission.Confirmed;
                                let completedOutPeriod = mission.Completed;
                                if (completedOutPeriod) {
                                    this.missionCompleted = true;
                                    this.isBtnDisable = true;
                                    break;
                                }
                                if ((confirmOutPeriod && maxQty) || confirmOutPeriod) {
                                    this.maxSubMissionQty = false;
                                    this.isBtnDisable = true;
                                    this.isShowBtnSpecial = false;
                                } else if (maxQty) {
                                    this.isBtnDisable = true;
                                    this.maxSubMissionQty = true;
                                } else {
                                    this.maxSubMissionQty = false;
                                    this.isBtnDisable = false;
                                    this.isButtonSpecial = true;
                                    this.missionCompleted = false;
                                    this.isShowBtnSpecial = true;
                                }
                            }
                        } else {
                            if (confirmed.length > 0 && subMission.CampaignQty == 0) {
                                this.maxSubMissionQty = false;
                            } else if (subMission.CampaignQty == 0) {
                                this.maxSubMissionQty = true;
                            } else {
                                this.maxSubMissionQty = false;
                            }
                            if (confirmed.length > 0) {
                                this.isBtnDisable = true;
                            }
                        }
                        // this.indexActive = i;
                        break;
                    }
                }
            }
        },
        getDateMissionSpecial: function(start, end) {
            start = DatetimeHelper.unixTimestampToDate(start);
            end = DatetimeHelper.unixTimestampToDate(end);
            start.setHours(0);
            start.setMinutes(0, 0, 0);
            end.setHours(0);
            end.setMinutes(0, 0, 0);
            let datediff = Math.abs(start - end);
            let diff = Math.round(datediff / (1000 * 60 * 60 * 24));
            this.timeCountDown = diff;
        },
        checkMissionMonth: function (date) {
            let missionCheckMonth = this.mission.SubMissions.filter((item,index) =>{
                    let start = new Date(item.StartDate * 1000);
                    let current = date.getMonth() + 1;
                    start = start.getMonth() + 1;
                    if (current == start) {
                        this.indexActive = index;
                    }
                    return current == start
                })[0];
            return missionCheckMonth;
        },
        getImgMissionTransaction: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl() + `/webconfig/${appId}/transaction/${this.mission.CampaignId}.png`;
        },
        clickDetailMission: function() {
            this.$router.push('/mission/transactiondetail/' + this.mission.Id);
        },
        //#region click join
        clickJoinMission: async function() {
            if (this.mission.UI != null) {
                if (this.isButtonSpecial) return;
            }
            let campaign = await this.apiRedeem();

            this.modal.loadingModal.show();
            await this.apiMissionConfirm(campaign.ItemNumber);
            this.modal.loadingModal.hide();
            window.location.reload();
        },
        getRedeemId: function(){
            if(this.mission && this.mission.SubMissions){
                //let today = new Date('September 6, 2023 18:59:59'); //for test
                let today = new Date();
                let submission = this.mission.SubMissions.filter((item) =>{
                    let start = DatetimeHelper.unixTimestampToDate(item.StartDate);
                    let end = DatetimeHelper.unixTimestampToDate(item.EndDate);
                    return (today >= start  && today <= end )
                })[0];

                if (submission) {
                    this.redeemId = submission.CampaignId ? submission.CampaignId : this.mission.CampaignId;
                } else {
                    this.redeemId = this.mission.CampaignId;
                }
            } else {
                this.redeemId = this.mission.CampaignId;
            }
        },
        apiRedeem: function(){
            return new Promise((resolve) =>{
                BzbsRedeem.apiRedeemCampaign(this.redeemId, null, 1).subscribe({
                    next: (campaign) => {
                        resolve(campaign)
                    },
                    error: (err) => {
                        this.errorApi(err);
                        console.log(err);
                        resolve(null)
                    },
                })
            })
        },
        apiMissionConfirm: function(itemNumber){
            return new Promise((resolve) =>{
                let params = {
                    id: this.mission.Id,
                    campaign: this.redeemId,
                    itemNumber: itemNumber,
                }
                MissionService.missionConfirm(params).subscribe({
                    next: (res) => {
                        resolve(res)
                    },
                    error: (err) => {
                        this.errorApi(err);
                        console.log(err);
                        resolve(null)
                    },
                })
            })
        },
        //#endregion click join
    }
}
</script>
<style lang="scss" scoped>
    .bg-mission-item{
        min-height: 144px;
        background-image: linear-gradient(120deg, #e7f3ff 5%, #fff 63%);
        box-shadow: 0 2px 5.9px 0 rgba(33, 64, 166, 0.15);
    }
    .bg-mission-special {
        min-height: 144px;
        background-image: linear-gradient(119deg, #0942b1 2%, #00f2ff 125%);;
    }
    .box-mission{
        min-height: 150px;

        .box-text{
            width: 70%;
        }
        .box-img{
            width: 30%;
            min-height: 190px;
        }
    }
</style>
